/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Route } from 'react-router-dom';
import { lazyLoadComponent } from '~shared/helpers/lazyLoadComponent';
import {
  DISALLOWED_DEPENDENCIES_ROUTE_NAME,
  DISCOVERY_ROUTE_NAME,
  MISPLACED_COMPONENTS_ROUTE_NAME,
  MODEL_ROUTE_NAME,
  MODEL_VISUAL_ROUTE_NAME,
  TANGLES_ROUTE_NAME,
} from '../helpers/urls';

const ArchitectureContainer = lazyLoadComponent(() => import('./common/ArchitectureContainer'));
const Dashboard = lazyLoadComponent(() => import('./dashboard/Dashboard'));
const Discovery = lazyLoadComponent(() => import('./discovery/Discovery'));
const ModelJsonEditor = lazyLoadComponent(() => import('./model/ModelJsonEditor'));
const ModelVisualEditor = lazyLoadComponent(() => import('./model/ModelVisualEditor'));
const Tangles = lazyLoadComponent(() => import('./tangles/Tangles'));
const DisallowedDependencies = lazyLoadComponent(
  () => import('./disallowed-dependencies/DisallowedDependencies'),
);
const MisplacedComponents = lazyLoadComponent(
  () => import('./misplaced-components/MisplacedComponents'),
);

export const architectureRoutes = () => (
  <Route element={<ArchitectureContainer />} path="architecture">
    <Route element={<Dashboard />} index />
    <Route element={<Discovery />} path={DISCOVERY_ROUTE_NAME} />
    <Route element={<ModelVisualEditor />} path={MODEL_VISUAL_ROUTE_NAME} />
    <Route element={<ModelJsonEditor />} path={MODEL_ROUTE_NAME} />
    <Route element={<DisallowedDependencies />} path={DISALLOWED_DEPENDENCIES_ROUTE_NAME} />
    <Route element={<MisplacedComponents />} path={MISPLACED_COMPONENTS_ROUTE_NAME} />
    <Route element={<Tangles />} path={TANGLES_ROUTE_NAME} />
  </Route>
);

export default architectureRoutes;
